import { useState } from "react";
import { Button } from "./ui/button";
import { Card } from "./ui/card";
import { Bot, X, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";

const RobotRecommendationWidget = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      {/* Floating Button */}
      <Button
        onClick={() => setIsOpen(true)}
        className="fixed bottom-20 right-4 md:bottom-6 md:right-6 z-40 rounded-full w-14 h-14 shadow-2xl bg-primary hover:bg-primary/90 flex items-center justify-center"
        aria-label="Get AI Robot Recommendation"
      >
        <Bot className="w-6 h-6" />
      </Button>

      {/* Widget Popup */}
      {isOpen && (
        <Card className="fixed bottom-36 right-4 md:bottom-24 md:right-6 z-40 w-[calc(100vw-2rem)] md:w-96 p-6 shadow-2xl border-2 border-primary/20 glass-effect">
          <div className="flex justify-between items-start mb-4">
            <div className="flex items-center gap-2">
              <Bot className="w-5 h-5 text-primary" />
              <h3 className="font-orbitron font-bold text-lg">Need Help Choosing?</h3>
            </div>
            <Button
              variant="ghost"
              size="sm"
              onClick={() => setIsOpen(false)}
              className="h-8 w-8 p-0"
            >
              <X className="w-4 h-4" />
            </Button>
          </div>
          
          <p className="text-sm text-muted-foreground mb-4">
            Let our AI-powered robot recommender help you find the perfect robot for your business needs.
          </p>

          <div className="space-y-2">
            <Button asChild className="w-full" size="sm">
              <Link to="/robot-recommender">
                Get AI Recommendation <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
            <Button 
              asChild 
              variant="secondary" 
              className="w-full" 
              size="sm"
            >
              <a href="https://api.leadconnectorhq.com/widget/bookings/neilaipudurobotics" target="_blank" rel="noopener noreferrer">
                Talk to an Expert
              </a>
            </Button>
          </div>
        </Card>
      )}
    </>
  );
};

export default RobotRecommendationWidget;
